import {
  permissionRouter,
  defaultRouter,
  basicRouter
} from '@/router'
import {
  getPermissions
} from '@/api/modules/system'

const permission = {
  state: {
    routes: [],
    asyncAddRoutes: [],
    asyncButton: [],
    asyncMenu: [],
    hasCreateRoutes: false,
    hasCreateButton: false,
    hasCreateMenu: false
  },
  mutations: {
    set_asyncRoutes: (state, routes) => {
      if (!state.hasCreateRoutes) {
        state.asyncAddRoutes = routes
        state.routes = defaultRouter.concat(routes)
        state.hasCreateRoutes = true
      }
    },
    set_button: (state, routes) => {
      if (!state.hasCreateButton) {
        state.asyncButton = routes
        state.hasCreateButton = true
      }
    },
    set_menu: (state, routes) => {
      if (!state.hasCreateMenu) {
        state.asyncButton = routes
        state.hasCreateMenu = true
      }
      state.asyncMenu = routes
    },
    set_logout: (state, routes) => {
      state.asyncAddRoutes = [],
      state.asyncButton = [],
      state.asyncMenu = [],
      state.routes = []
      state.hasCreateRoutes = routes
      state.hasCreateButton = routes
      state.hasCreateMenu = routes
      console.log('empty state', state)
    }
  },
  actions: {
    asyncRoutesQuery({ commit }) {
      // console.log('8')
      return new Promise(resolve => {
        // 获取权限树
        const asyncMenuRouter = []
        const asyncButton = []
        const asyncMenu = []
        return getPermissions().then(req => {
          // console.log('9',req)
          req.permissionList.map(list => {
            if (list) {
              if (list.permissionType === 'M') {
                // 菜单权限
                asyncMenuRouter.push(list.frontUri)
                asyncMenu.push(list.permissionCode)
              }
              if (list.permissionType === 'B') {
                // 按钮权限
                asyncButton.push(list.permissionCode)
              }
            }
          })
          const storePermission = _.cloneDeep(permissionRouter) // 本地路由
          let len = storePermission.length
          while (len--) {
            if (storePermission[len].children) {
              let len2 = storePermission[len].children.length
              while (len2--) {
                if (!asyncMenuRouter.includes(storePermission[len].children[len2].path)) {
                  storePermission[len].children.splice(len2, 1)
                }
              }
            } else {
              if (!asyncMenuRouter.includes(storePermission[len].path)) {
                storePermission.splice(len, 1)
              }
            }
          }
          commit('set_asyncRoutes', [...new Set(storePermission.concat(basicRouter))])
          commit('set_menu', [...new Set(asyncMenu)])
          commit('set_button', [...new Set(asyncButton)])
          resolve(true)
        }).catch(() => {
          resolve(false)
        })
      })
    },
    routerLogout({
      commit
    }) {
      // console.log('12333,123123')
      return new Promise(resolve => {
        // console.log('2134')
        commit('set_logout', false)
        resolve()
      })
    }
  },
  getters: {
    asyncAddRoutes: state => state.asyncAddRoutes,
    routes: state => state.routes,
    asyncMenu: state => state.asyncMenu,
    asyncButton: state => state.asyncButton

  }
}

function loopDeep(data, asyncMenuRouter, asyncButton, asyncMenu) {
  // 递归节点
  data.map(list => {
    // console.log('list', list.nameEn)
    if (list) {
      if (list.permissionType === 'M') {
        // 菜单权限
        asyncMenuRouter.push(list.frontUri)
        asyncMenu.push(list.permissionCode)
      }
      if (list.permissionType === 'B') {
        // 按钮权限
        asyncButton.push(list.permissionCode)
      }
    }
  })
}

// function loopCompare(data,sourceData) {
// 	const dataSource = sourceData.filter((list, index) => {
// 		if (sourceData[index]) {
// 			if (!!sourceData[index]['children'] && sourceData[index].children.length > 0) {
// 				return loopCompare(data, sourceData[index].children)
// 			}
// 		}
// 	})
// 	return dataSource
// }

export default permission
